import { t } from "i18next";

export const formatPrice = (price: number) => {
  return `${t("common.currency")}${price / 100}`;
};
